/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveDiagonal2 = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "5 11 5 5 11 5" }],
    ["polyline", { points: "19 13 19 19 13 19" }],
    ["line", { x1: "5", x2: "19", y1: "5", y2: "19" }]
  ]
];

export { MoveDiagonal2 as default };
//# sourceMappingURL=move-diagonal-2.js.map
